<!-- 油卡积分记录 -->
<template>
  <van-popup class="popup" v-model="ifShow" position="right" :overlay="false">
    <div class="popup_title">
      <span>{{card_no}} | {{card_name}}</span>
      <van-button type="default" round size="small" @click="ifShow = false">返 回</van-button>
    </div>
    <v-touch class="popup_body" @swiperight="ifShow = false" >
    <van-pull-refresh v-model="down_loading" @refresh="pulldown">
      <span v-if="data.length > 0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMore">
          <van-cell  v-for="(val, key) in data" :key="key" center :title="val.name" :value="val.val" :label="val.date" value-class="money" title-style="font-size:14px"/>
        </van-list>
      </span>
      <van-empty v-else description="暂无记录" />
    </van-pull-refresh>
    </v-touch>
  </van-popup>
</template>
<style lang="scss" scoped>
  .money {
    font-size: 16px;
    color: #303133;
  }
  .van-cell__title , .van-cell__value {
    flex:auto;
  }
</style>
<script>
export default {
  name: 'card_bill',
  data () {
    return {
      ifShow: false,
      loading: false,
      finished: false,
      down_loading: false,
      card_name: '',
      card_no: '',
      card_id: '',
      page: 1,
      size: 15,
      data: []
    }
  },

  methods: {
    // 显示弹层
    show (data) {
      this.card_id = data.card_id
      this.card_name = data.type_name
      this.card_no = data.card_no
      this.data = []
      this.page = 1
      this.finished = false
      this.ifShow = true
      this.get_data()
    },

    // 获取数据
    get_data () {
      let data = {
        card_id: this.card_id,
        page: this.page,
        size: this.size
      }
      this.ax(this, 'sel_card_inte', data, (res) => {
        if (res.err_num === 0) {
          this.page = res.data.page
          this.data = this.data.concat(res.data.data)
          this.loading = false
          this.down_loading = false

          // 判断是否还有更多
          if (res.data.data.length < this.size) {
            this.finished = true
          }
        }
      })
    },

    // 上拉加载更多
    loadMore () {
      this.page += 1
      this.get_data()
    },

    // 下拉刷新
    pulldown () {
      this.finished = false
      this.page = 1
      this.data = []
      this.get_data()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/card/inte.vue